import {createReducer} from "./index";

const activityReducer = createReducer([],
  {
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default activityReducer;


// WEBPACK FOOTER //
// ./src/reducers/activity.js